import * as z from "zod";

export const ProductComparisonFeatureSchema = z.object({
  name: z.string().describe("Name of the feature being compared"),
  currentProduct: z
    .string()
    .describe("Value for the current product being compared"),
  similarProduct: z
    .string()
    .describe("Value for the similar alternative product"),
});

export const ConfirmCompareProductsSchema = z.object({
  currentProductId: z.string(),
  currentProductTitle: z.string(),
  similarProductId: z.string(),
  similarProductTitle: z.string(),
  comparisonFeatures: z
    .array(ProductComparisonFeatureSchema)
    .describe("Key features to compare between the products"),
  recommendation: z
    .string()
    .nullable()
    .describe(
      "Very concise recommendation on which product might be better suited",
    ),
});

export type ProductComparisonFeature = z.infer<
  typeof ProductComparisonFeatureSchema
>;
export type ConfirmCompareProducts = z.infer<
  typeof ConfirmCompareProductsSchema
>;
